import sopClassDictionary from '../util/sopClassDictionary';
import { getConfig } from '../static/config';

/**
 * Checks whether dicom files with specified SOP Class UID have image data
 * @param {string} SOPClassUID - SOP Class UID to be checked
 * @returns {boolean} - true if it has image data
 */

export default function isDocument(SOPClassUID) {
  const isOliveGuma = getConfig().IS_OLIVE_GUMA_BUILD;

  return (
    SOPClassUID === sopClassDictionary.BasicTextSR
    || SOPClassUID === sopClassDictionary.EnhancedSR
    || SOPClassUID === sopClassDictionary.ComprehensiveSR
    || SOPClassUID === sopClassDictionary.ProcedureLog
    || SOPClassUID === sopClassDictionary.MammographyCADSR
    || SOPClassUID === sopClassDictionary.ChestCADSR
    || SOPClassUID === sopClassDictionary.XRayRadiationDoseSR
    || SOPClassUID === sopClassDictionary.EncapsulatedPDFStorage
    || SOPClassUID === sopClassDictionary.GrayscaleSoftcopyPresentationStateStorage
    || SOPClassUID === sopClassDictionary.KeyObjectSelection
    || (isOliveGuma && SOPClassUID === sopClassDictionary.SecondaryCaptureImageStorage) // only for olive guma
  );
}
